import React from 'react'
import { Home as icons } from '../../assets/images'
import { Button } from '../Button'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import './index.scss'

export const Disclaimer = function () {
    const [isConfirmed, setIsConfirmed] = React.useState(!!localStorage.getItem('disclaimer-confirmed'))
    const { t } = useTranslation()

    return (
        <div className={classNames('disclaimer-modal', isConfirmed ? 'hide' : 'show')}>
            <div className='disclaimer'>
                <img src={icons.disclaimer} />
                <h3>{t('home.disclaimer.h3')}</h3>
                <p>{t('home.disclaimer.p')}</p>
                <Button onClick={() => {
                    setIsConfirmed(true)
                    localStorage.setItem('disclaimer-confirmed', 'true')
                }}>{t('home.disclaimer.button')}</Button>
                <svg onClick={() => {
                    setIsConfirmed(true)
                }} className='close-btn' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19.6367 4.36328L4.36321 19.6368" stroke="black" strokeWidth="1.8" />
                    <path d="M19.6367 19.6367L4.36321 4.36321" stroke="black" strokeWidth="1.8" />
                </svg>
            </div>
        </div>
    )
}